import { ChatMessageType, ReplyMessageType } from "@data-types/chat";
import { useRootAppStore } from "@hooks";

export default function useReplyMessage(inputValue: string, isLink: boolean) {
	const {
		chatViewStore: { selectedMessageToReplyOn },
	} = useRootAppStore();

	if (!selectedMessageToReplyOn) {
		return;
	}

	let replyingMessage: ReplyMessageType = {
		messageId: "",
		text: "",
		replyingCreatorId: "",
		replyingMessage: "",
		sharedSlip: null,
		isLink: false,
		isMultiOffer: false,
	};

	//this has to be this way because you cannot send empty value to amity on message reply
	const messageText = inputValue ? inputValue : " ";

	if (
		!selectedMessageToReplyOn.data.sharedSlip &&
		!selectedMessageToReplyOn.data.betSlipData
	) {
		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: selectedMessageToReplyOn.data.text,
			sharedSlip: null,
			isLink: isLink,
			isMultiOffer: false,
		};
	} else if (
		selectedMessageToReplyOn.data.sharedSlip &&
		selectedMessageToReplyOn.data.betSlipData
	) {
		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: selectedMessageToReplyOn.data.text,
			sharedSlip: selectedMessageToReplyOn.data.betSlipData,
			isLink: isLink,
			isMultiOffer: false,
		};
	} else if (
		selectedMessageToReplyOn.data.messageType == ChatMessageType.REPLY &&
		selectedMessageToReplyOn.data.sharedSlip &&
		!selectedMessageToReplyOn.data.betSlipData
	) {
		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: selectedMessageToReplyOn.data.text,
			sharedSlip: null,
			isLink: isLink,
			isMultiOffer: false,
		};
	} else if (
		selectedMessageToReplyOn.data.messageType == ChatMessageType.REPLY &&
		!selectedMessageToReplyOn.data.sharedSlip &&
		selectedMessageToReplyOn.data.betSlipData
	) {
		const replyingMessageText = selectedMessageToReplyOn.data.text
			? selectedMessageToReplyOn.data.text
			: " ";

		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: replyingMessageText,
			sharedSlip: selectedMessageToReplyOn.data.betSlipData,
			isLink: isLink,
			isMultiOffer: false,
		};
	} else if (
		selectedMessageToReplyOn.data.messageType != ChatMessageType.REPLY &&
		selectedMessageToReplyOn.data.sharedSlip &&
		!selectedMessageToReplyOn.data.betSlipData
	) {
		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: selectedMessageToReplyOn.data.text,
			sharedSlip: selectedMessageToReplyOn.data.sharedSlip,
			isLink: isLink,
			isMultiOffer:
				selectedMessageToReplyOn.data?.sharedSlip?.hasBetBuilder,
		};
	} else {
		const { data } = selectedMessageToReplyOn;

		const text =
			data?.messageType != ChatMessageType.REPLY
				? data.msg
					? data.msg
					: data.text
				: data.replyingMessage;

		replyingMessage = {
			messageId: selectedMessageToReplyOn.messageId,
			text: messageText,
			replyingCreatorId: selectedMessageToReplyOn.creatorId,
			replyingMessage: text,
			sharedSlip: selectedMessageToReplyOn.data.sharedSlip,
			isLink: isLink,
			isMultiOffer:
				selectedMessageToReplyOn.data?.sharedSlip?.hasBetBuilder ||
				selectedMessageToReplyOn.data?.betSlipData?.hasBetBuilder,
		};
	}

	return replyingMessage;
}
